import { createElement as _createElement } from "react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { AvatarColor } from '../../avatar';
import { Chip } from '../../chip';
import { getIcon } from '../../icon';
const MAX_TAGS = 10;
function renderTags(values, getChipProps, props) {
    const tagLimit = props.limitTags ?? MAX_TAGS;
    const showMoreTags = values.length > tagLimit;
    const showMoreTagsLabel = `+${values.length - tagLimit}`;
    return (_jsxs(_Fragment, { children: [values.slice(0, tagLimit).map((value, index) => {
                const chipProps = getChipProps({ index });
                const externalProps = props.getChipProps?.(value) ?? {};
                const icon = (() => {
                    if (props.getOptionColor) {
                        return (_jsx(AvatarColor, { color: props.getOptionColor(value) }));
                    }
                    if (props.getOptionIcon) {
                        const { icon, iconProps = {} } = props.getOptionIcon(value);
                        const Icon = getIcon(icon);
                        return _jsx(Icon, { ...iconProps });
                    }
                    return undefined;
                })();
                return (_createElement(Chip, { ...chipProps, key: `tag-${index}`, label: props.getOptionLabel?.(value) ??
                        value, icon: icon, ...externalProps, sx: {
                        maxWidth: ({ spacing }) => {
                            return `calc(50% - ${spacing(0.5)}) !important`;
                        }
                    } }));
            }), showMoreTags && (_jsx(Chip, { cursor: "default", label: showMoreTagsLabel }))] }));
}
export default { renderTags };
